import React, { useEffect, useState } from "react";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { ReactComponent as BankingAalytics } from "../../icons/dashboard/bankingAnalytics.svg";
import { ReactComponent as ConsumptionAndGenerationAnalytics } from "../../icons/dashboard/consumptionAndGenerationAnalytics.svg";
import { ReactComponent as DemandForecasting } from "../../icons/dashboard/demandForecasting.svg";
import { ReactComponent as ExchangeAnalysis } from "../../icons/dashboard/exchangeAnalysis.svg";
import { ReactComponent as GridFrequencyProfile } from "../../icons/dashboard/gridFrequencyProfile.svg";
import { ReactComponent as PowerAtlas } from "../../icons/dashboard/powerAtlas.svg";
import { ReactComponent as Upload } from "../../icons/upload.svg";
import { ReactComponent as AnalyticsIcon } from "../../icons/analytics.svg";
import { ReactComponent as AnalyticsSelectedIcon } from "../../icons/analytics-selected.svg";
import { COLOR_CODES, isMobile } from "../../common";
import { ReactComponent as DashboardIcon } from "../../icons/dashboard.svg";
import { ReactComponent as DashboardSelectedIcon } from "../../icons/dashboard-selected.svg";
import Hamburger from "../../components/Hamburger";
import { HpgclTitle } from "./components";
import OverviewDas from "./OverviewDashboard/Overview_Das";
import { IconTab } from "../../components/IconTab";
import { PageHeader } from "../../components/Page";

function HppclDashboardItem({
  title,
  Icon,
  to,
  disabled = false,
}: {
  title: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  to: string;
  disabled?: boolean;
}) {
  if (disabled) {
    return (
      <div className="dashboard-item dashboard-item-disabled">
        <Icon
          width={80}
          height={33}
          style={{
            fill: COLOR_CODES.primary,
            opacity: 0.5,
          }}
        />
        <p style={{ opacity: 0.5 }}>{title}</p>
      </div>
    );
  }

  return (
    <NavLink to={`${to}`} className="dashboard-item">
      <Icon
        width={80}
        height={33}
        style={{
          fill: COLOR_CODES.primary,
        }}
      />
      <p>{title}</p>
    </NavLink>
  );
}

export default function HpgclDashboard() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") || "dashboard";
  const [selectedTab, setSelectedTab] = useState(initialTab);

  useEffect(() => {
    const tab = searchParams.get("tab") || "dashboard";
    if (tab !== selectedTab) {
      setSelectedTab(tab);
    }
  }, [searchParams, selectedTab]);

  const handleTabChange = (tab: string) => {
    setSelectedTab(tab);
    setSearchParams({ tab });
  };

  return (
    <>
      <div className="page-wrapper">
        <PageHeader
          leftComponent={
            <div className="flex flex-row md:gap-x-4 gap-x-2 items-center">
              {!isMobile && <Hamburger />}
              <IconTab
                tabs={[
                  { key: "analytics", icon: AnalyticsIcon, selectedIcon: AnalyticsSelectedIcon },
                  { key: "dashboard", icon: DashboardIcon, selectedIcon: DashboardSelectedIcon },
                ]}
                selected={selectedTab}
                onChange={handleTabChange}
              />
            </div>
          }
          middleComponent={<HpgclTitle />}
        />

        {selectedTab === "analytics" ? (
          <div className="page-wrapper">
            <OverviewDas />
          </div>
        ) : (
          <div className="dashboard-item-container">
            <div className="flex flex-col justify-between h-full">
              <div className="flex flex-row flex-wrap gap-5 justify-center">
                {/* <GridcoDashboardItem Icon={MarketMonitoring} title="Market Monitoring" to="marketmonitoring" /> */}
                <HppclDashboardItem
                  Icon={PowerAtlas}
                  title="Overview"
                  to="overview"
                  disabled={true}
                />
                <HppclDashboardItem
                  Icon={DemandForecasting}
                  title="Demand Analytics"
                  to="demand"
                />
                <HppclDashboardItem
                  Icon={ConsumptionAndGenerationAnalytics}
                  title="Generation Analytics"
                  to="#"
                  disabled={true}
                />
                <HppclDashboardItem
                  Icon={ExchangeAnalysis}
                  title="Power Procurement"
                  to="procurement"
                />
                <HppclDashboardItem
                  Icon={ExchangeAnalysis}
                  title="Exchange Analytics"
                  to="exchangeAnalysis"
                />
                <HppclDashboardItem
                  Icon={BankingAalytics}
                  title="Surplus Deficit"
                  to="Surplus"
                />

                <HppclDashboardItem
                  Icon={BankingAalytics}
                  title="Automation"
                  to="#"
                  disabled={true}
                />

                <HppclDashboardItem
                  Icon={Upload}
                  title="Upload Data"
                  to="#"
                  disabled={true}
                />

                <HppclDashboardItem
                  Icon={GridFrequencyProfile}
                  title="Transactions"
                  to="#"
                  disabled={true}
                />
              </div>
              <div className="gna-footer-container mt-8">
                <div className="grid grid-cols-3 justify-between items-center gap-5 ">
                  <h3 className="text-[#9f9f9f] font-medium text-[13px]">
                    GNA Energy Data and Analytics Capability Center (GDACC)
                  </h3>
                  <p className="gna-footer-text text-center">
                    Powered by <strong>GNA Energy</strong>
                  </p>
                  <strong className="gna-footer-text text-end">
                    Beta Version
                  </strong>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export const TabSwitcher: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab") || "dashboard";

  const handleTabChange = (newTab: string) => {
    navigate(`/hppc?tab=${newTab}`);
  };

  return (
    <IconTab
      tabs={[
        { key: "analytics", icon: AnalyticsIcon, selectedIcon: AnalyticsSelectedIcon },
        { key: "dashboard", icon: DashboardIcon, selectedIcon: DashboardSelectedIcon },
      ]}
      selected={tab}
      onChange={handleTabChange}
    />
  );
};
